import React from 'react';

interface Props {
  className?: string;
  width?: number;
  height?: number;
  color?: string;
}

const MagnifyingGlassIcon = ({
  className,
  width = 24,
  height = 24,
  color = 'currentColor',
}: Props) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.2325 19.85L14.6225 14.24C16.4625 11.72 16.2525 8.16 13.9825 5.89C12.7625 4.67 11.1525 4 9.4325 4C7.7125 4 6.0925 4.67 4.8825 5.89C2.3725 8.4 2.3725 12.48 4.8825 15C6.1025 16.22 7.7125 16.89 9.4325 16.89C10.9825 16.89 12.4425 16.34 13.6025 15.35L19.1725 20.92L20.2325 19.86V19.85ZM9.4325 15.38C8.1125 15.38 6.8725 14.87 5.9425 13.93C4.0125 12 4.0125 8.87 5.9425 6.95C6.8725 6.02 8.1125 5.5 9.4325 5.5C10.7525 5.5 11.9925 6.01 12.9225 6.95C14.8525 8.88 14.8525 12.01 12.9225 13.93C11.9925 14.86 10.7525 15.38 9.4325 15.38Z"
      fill={color}
    />
  </svg>
);

export default MagnifyingGlassIcon;
